<template>
	<div>
       <b-overlay :show="psLoading" opacity="0.2">
            <vue-perfect-scrollbar class="card-wrapper">
                <table class="table table-bordered table-sm mb-1 ">
                    <thead>
                        <tr>
                            <th class="text-nowrap w-10">Müşteriye Gönderildi Mi?</th>
                            <th class="text-nowrap w-10">Ödeme Kodu</th>
                            <th class="text-nowrap w-10">Cari Kod</th>
                            <th class="text-nowrap w-10">Cari Adı</th>
                            <th class="text-nowrap w-20">Açıklama</th>
                            <th class="text-nowrap w-7">Gönderilme Tarihi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(ps,i) in paymentRequests" >
                            <tr :key="i">
                                <td class="text-nowrap">
                                    <span v-if="ps.IsSentToCustomer" class="material-icons-outlined text-success">check_circle</span>
                                    <span v-else class="material-icons-outlined text-danger">cancel</span>
                                </td>
                                <td class="text-nowrap">
                                    <a :href="'/Payment/'+ps.PaymentCode" target="_blank">{{$safe(ps,'PaymentCode') || '-'}}</a>
                                </td>
                                <td class="text-nowrap">{{$safe(ps,'CustomerCode') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(ps,'CustomerName') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(ps,'Description') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(ps,'CreateTime') || '-'}}</td>
                            </tr>
                            <tr  :key="i + '-dl'" v-if="ps.PaymentActions">
                                <td colspan="20">
                                    <div class="table-responsive mb-0">
                                        <table class="table table-bordered table-sm">
                                            <thead>
                                            
                                                <th class="text-nowrap w-15">Toplam Ödenecek Tutar</th>
                                                <th class="text-nowrap w-15">Ödenen Tutar</th>
                                                <th class="text-nowrap w-15">Kalan Tutar</th>
                                                <th class="text-nowrap w-30">Durum</th>
                                                <th class="text-nowrap w-25">Ödeme Zamanı</th>

                                            </thead>
                                            <tbody>
                                                <tr :class="setPaymentStatusColor(dl.Status)" v-for="(dl,index) in ps.PaymentActions" :key="index">
                                                    
                                                    <td>{{$safe(dl,'TotalAmount') || '-'}}</td>
                                                    <td>{{$safe(dl,'PaidAmount') || '-'}}</td>
                                                    <td>{{$safe(dl,'RemainingAmount') || '-'}}</td>
                                                    <td>{{$safe(dl,'StatusStr') || '-'}}</td>
                                                    <td>{{$safe(dl,'PaidTime') || '-'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="paymentRequests.length == 0">
                            <td colspan="20" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
            </vue-perfect-scrollbar>
        </b-overlay>

	</div>
</template>

<script>
import { BCard, BCardText, BLink,BImg,BOverlay,BSpinner } from 'bootstrap-vue'
//import Notifications from '@/utilities/notifications'
import {PaymentApi} from '@/api/payment'
import VStatsBox from '@/components/VStatsBox.vue'
import Auth from '@/utilities/auth'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
    props:{
        code:String
    },
    components: {
        BCard,
        BCardText,
        BLink,
        BImg,
        VStatsBox,
        VuePerfectScrollbar,
        BOverlay,
        BSpinner
    },
    data() {
        return {
            month:null,
            paymentRequests:[],
            responsibleUserPaymentStatuses:[],
            psLoading:false,
            rupsLoading:false,
            approving:false,
            cid:null,
            pending:false
        }
    },
    mounted(){
        this.paymentRequestList()
    },
    methods:{
        setPaymentStatusColor(paymentStatus){
            if(paymentStatus == 6 || paymentStatus == 7)
                return 'bg-light-success'
            if(paymentStatus == 5)
                return 'bg-light-primary'
            if(paymentStatus == 4 || paymentStatus == 2)
                return 'bg-light-danger'
            if(paymentStatus == 0)
                return 'bg-light-info'
                if(paymentStatus == 3)
                return 'bg-light-warning'
            return ''
        },
        paymentRequestList(){
            this.psLoading = true
            PaymentApi.PaymentRequestByCode(this.code).then(res=>{
                this.psLoading = false
                this.paymentRequests = res.data.Data
            }).catch(()=>this.psLoading = false)
        },
    }
}
</script>

<style>

</style>
